<template>
  <mt-tabbar v-model="message" class="tabbar">
    <!-- <mt-tab-item class="mtTabItemChange" id="reminder" @click="remindMeds">
      </mt-tab-item> -->
    <mt-tab-item
      class="mtTabItemChange reminderClick"
      id="reminder"
      @click="goNavigator(1,'reminder')"
    >
      <img
        v-show="changImg == 'reminder'"
        slot="icon"
        src="../assets/reminder/tab-ic-1@2x.png"
      />
      <img
        v-show="changImg != 'reminder'"
        slot="icon"
        src="../assets/reminder/tab_ic_提醒_1@2x.png"
      />
      提醒
    </mt-tab-item>
    <mt-tab-item
      class="mtTabItemChange reminderClick"
      id="healthCalendar"
      @click="goNavigator(2,'healthCalendar')"
    >
      <img
        v-show="changImg == 'healthCalendar'"
        slot="icon"
        src="../assets/reminder/tab-ic-2@2x.png"
      />
      <img
        v-show="changImg != 'healthCalendar'"
        slot="icon"
        src="../assets/reminder/tab_ic__1@2x.png"
      />
      日历
    </mt-tab-item>

    <mt-tab-item
      id="virtualMedicine"
      class="mtTabItemChange"
      @click="goNavigator(3,'virtualMedicine')"
    >
      <img
        v-show="changImg == 'virtualMedicine'"
        slot="icon"
        src="../assets/reminder/tab-ic-4@2x.png"
      />
      <img
        v-show="changImg != 'virtualMedicine'"
        slot="icon"
        src="../assets/reminder/tab_ic_药箱_1@2x.png"
      />
      药箱
    </mt-tab-item>

    <mt-tab-item
      id="medicalRecord"
      class="mtTabItemChange"
      @click="goNavigator(4,'medicalRecord')"
    >
      <img
        v-show="changImg == 'medicalRecord'"
        slot="icon"
        src="../assets/reminder/tab-ic-3@2x.png"
      />
      <img
        v-show="changImg != 'medicalRecord'"
        slot="icon"
        src="../assets/reminder/tab_ic_病例_1@2x.png"
      />
      诊籍
    </mt-tab-item>

    <mt-tab-item id="my" class="mtTabItemChange" @click="goNavigator(5,'my')">
      <img
        v-show="changImg == 'my'"
        slot="icon"
        src="../assets/reminder/tab-ic-5@2x.png"
      />
      <img
        v-show="changImg != 'my'"
        slot="icon"
        src="../assets/reminder/tab_ic_我的_1@2x.png"
      />
      我的
    </mt-tab-item>

    <div
      class="cameraDiv"
      style="justify-content: center;display: flex;"
      v-show="changImg == 'my'"
    >
      <!-- <div
        @click="jumpNucleicAcids"
        class="cameraImg"
        v-btnPermission="['HOM']"
      >
        <div style="color: white;margin-top: 9px;font-size: 16px;">
          便民
        </div>
      </div> -->
    </div>
  </mt-tabbar>
</template>

<script>
import { mapGetters } from "vuex";
import $ from "jquery";
export default {
  name: "Footer",
  components: {
    Header: "Header"
  },
  props:['changeMessage'],
  computed:{
    ...mapGetters("app", ["isTabbar"])
  },
  mounted: function() {
    // 页面返回做操作
    if (this.$route.name == "my") {
      this.changImg = "my";
      this.message = "my";
    } else if (this.$route.name == "queryNucleicAcid") {
      this.changImg = "nucleicAcid";
      this.message = "nucleicAcid";
    } else if (this.$route.name == "virtualMedicine") {
      this.changImg = "virtualMedicine";
      this.message = "virtualMedicine";
    } else if (this.$route.name == "flags") {
      this.changImg = "flags";
      this.message = "flags";
    } else if (this.$route.name == "medicalRecord") {
      this.changImg = "medicalRecord";
      this.message = "medicalRecord";
    } else if (this.$route.name == "community1/index") {
      this.changImg = "community1";
      this.message = "community1";
    } else if (this.$route.name == "healthCalendar") {
      this.changImg = "healthCalendar";
      this.message = "healthCalendar";
    }
    this.getEpidemicPrevention();
  },
  data() {
    return {
      value: true,
      message: "reminder",
      changImg: "reminder",
      isFlag: true
    };
  },
  // mounted(){
  //  if(window.jumpNucleicAcids && window.jumpNucleicAcids.call){
  //   this.isFlag = true
  //  }
  // },
  methods: {
    getDiffTime1(new_date, old_date) {
      var subtime = (new_date - old_date) / 1000; //计算时间差,并将毫秒转化为秒
      var days = parseInt(subtime / 86400); //天  24*60*60*1000
      var hours = parseInt(subtime / 3600) - 24 * days; //小时  60*60  总小时数-过去小时数=现在小时数
      //var mins = parseInt(subtime % 3600 / 60);    //分钟 - (day*24)  以60秒为一整份  取余 剩下秒数 秒数/60就是分钟数
      //var secs = parseInt(subtime % 60);   //以60秒为一整份  取余  剩下秒数
      return {
        days: days,
        hours: hours
      };
      //return "时间差是：" + days + "天 " + hours + "小时 " + mins + "分钟 " + secs + "秒 ";
    },
    getEpidemicPrevention() {
      console.log(123);
      let epidemicPrevention = localStorage.getItem("epidemicPrevention"); //防疫 每隔六小时拉一次
      let time = this.utils.getNowTime(); //获取当前时间
      if (!epidemicPrevention) {
        //为空拉一次，拉完以后记录时间
        localStorage.setItem("epidemicPrevention", time); //缓存当前时间
        // this.jumpNucleicAcids();
      } else {
        let data = this.getDiffTime1(
          new Date(time),
          new Date(epidemicPrevention)
        );
        if (data.days > 0 || data.hours >= 2) {
          //校验时间与当前时间是否大于两小时
          localStorage.setItem("epidemicPrevention", time); //缓存当前时间
          // this.jumpNucleicAcids();
        }
      }
    },

    goCommunity1() {
      this.utils.$routPush(this, "/community1/index");
    },
    // jumpNucleicAcids() {
    //   this.utils.$routPush(this,'/community/index');

    //   let data = {
    //     webAction: "jumpNucleicAcids"
    //   };
    //   if (window.jumpNucleicAcids && window.jumpNucleicAcids.call) {
    //     //
    //     this.utils.doTnucleicAcid("核酸", this);
    //     const result = window.jumpNucleicAcids.call(JSON.stringify(data));
    //   }
    // },
    goNavigator(type,name){
      this.changImg = name;
      this.message = name;
    },
    goFlags() {
      this.utils.$routPush(this, "/flags");
    },
  },
  watch: {
    $route(to, from){
      if(to.path.split("/")[1] == 'virtualMedicine'){
        this.message = to.path.split("/")[1]
      }

    },
    message: function(val, oldVal) {
      // debugger
      this.changImg = val;
      if (oldVal == "nucleicAcid") {
        return false;
      }
      if (val == "nucleicAcid") {
        this.message = oldVal;
      }
      if (location.hash == `#/${val}`) {
        return false;
      }
      // debugger
      // 这里就可以通过 val 的值变更来确定去向
      switch (val) {
        case "reminder":
          $("#reminder").click();
          this.utils.$routPush(this, "/remindMeds");
          break;
        case "nucleicAcid":
          //this.utils.$routPush(this,'/queryNucleicAcid');
          // this.jumpNucleicAcids();
          //this.utils.$routPush(this,'/queryNucleicAcid');
          break;
        case "virtualMedicine":
          $("#virtualMedicine").click();
          this.utils.$routPush(this, "/virtualMedicine");
          break;
        case "flags":
          $("#flags").click();
          this.utils.$routPush(this, "/flags");
          break;
        case "medicalRecord":
          $("#medicalRecord").click();
          this.utils.$routPush(this, "/medicalRecord");
          break;
        case "my":
          $("#my").click();
          this.utils.$routPush(this, "/my");
          break;
        case "community1":
          $("#community1").click();
          this.utils.$routPush(this, "/community1/index");
          break;
        case "healthCalendar":
          $("#healthCalendar").click();
          this.utils.$routPush(this, "/healthCalendar");
          break;
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.tabbar {
  border-top: solid 1px #e1e1e1;
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 9;
  right: 0;
  // padding-bottom: constant(safe-area-inset-bottom);
  // padding-bottom: env(safe-area-inset-bottom);
}

.colorWhite {
  /* color: white; */
  margin-top: -5px;
}
.cameraImgWhite {
  background: white !important;
  /* border: 1px solid #b6bac4; */
  color: #b6bac4 !important;
}
.cameraImg {
  bottom: 3.5em;
  opacity: 0.92;
  position: fixed;
  z-index: 3;
  width: 60px;
  height: 40px;
  border-radius: 50%;
  background-size: 100% 100%;
  left: 50%;
  transform: translateX(-50%);
  /* background: #35599c; */
  color: white;
  /* border: 1px solid #35599c; */
  background-image: url("../../static/back_bubble.jpg");
}
.cameraDiv {
  position: fixed;
  bottom: 0px;
}
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
// .mint-tabbar.is-fixed {
//   // z-index: 998;
// }
.mint-tabbar.is-fixed > .mint-tab-item.is-selected {
  background-color: #ffffff;
  color: #1191f3 !important;
}

.mint-tab-item {
  padding-bottom: calc(7px + constant(safe-area-inset-bottom));
  padding-bottom: calc(7px + env(safe-area-inset-bottom));
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue